import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { Card, Typography, Button, Icon } from '@sravni/react-design-system';
import { ContentPenEdit } from '@sravni/react-icons';
import { useCallback } from 'react';

import { TEXT_COMMA_SEPARATOR } from 'constants/string';

import type { TWorkplaceFormFields } from 'entities/creditForm';

import { WorkplaceInfoTexts } from 'features/UpdateWorkplaceInfo/WorkplaceInfo.texts';

import styles from './OrganizationSummary.module.scss';

export const OrganizationSummary: FC = () => {
  const { watch, setValue } = useFormContext<TWorkplaceFormFields>();
  const workAddress = watch('workAddress.label');
  const workOrganizationName = watch('workOrganizationName');
  const inn = watch('employerInn');

  const organizationSummaryText = [workOrganizationName, inn, workAddress].filter(Boolean).join(TEXT_COMMA_SEPARATOR);

  const onEditClick = useCallback(() => {
    setValue('isWorkOrganizationManuallyFilled', true, { shouldValidate: false });
  }, [setValue]);

  return (
    <Card
      className={styles.organizationSummaryCard}
      variant="secondary"
      color="blue"
    >
      <div className={styles.textBlock}>
        <Typography.Text
          size={12}
          className="h-color-D60"
        >
          {WorkplaceInfoTexts.workAddress}
        </Typography.Text>
        <Typography.Text size={16}>{organizationSummaryText}</Typography.Text>
      </div>
      <Button
        variant="text"
        color="blue"
        onClick={onEditClick}
        className={styles.editButton}
      >
        <Icon
          size={24}
          icon={<ContentPenEdit />}
        />
      </Button>
    </Card>
  );
};
